/*
 * Copyright (C) 2018 Bruno López Trigo
 * 
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import {Checkbox, TextField, Tooltip} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import CardActionArea from "@material-ui/core/CardActionArea";
import WekaLogo from "../images/WekaLogo.png"
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from "@material-ui/icons/Help";


const TextOnlyTooltip = withStyles({
  tooltip: {
    color: "white",
    backgroundColor: "#ff9800",
    fontSize: "1em"
  }
})(Tooltip);
const styles = {
  card: {
    minWidth: 200,
    width: "30%",
    margin: 20,
    maxWidth: 400,
    backgroundColor:"#e7e7e7",

  },
  media: {
    height: 140,
    width: 400,
    margin: "auto",
    backgroundSize:"auto",
    backgroundColor:"white",

  },
  buttonSelect: {
    fontSize: "16px",
    color: "#4caf50"
  },
  content: {
    textAlign: "center"
  },
  link: {
    textDecoration: "none"
  },
  actionArea:{
    display:"block",
    backgroundSize:"auto"
  },
  buttonInfo: {
    fontSize: "16px",
    color: "#687aff",
    width: "50%"
  },
};

function DatasetCardBeginner(props) {
  const { classes } = props;
  const [checked, setChecked] = useState(props.checked);
  const [helpTool, setHelpTool] = useState(true);
  const [name, setName] = React.useState("example");

  function handleDatasetChange() {
    if (checked) {
      setChecked( false)
    } else {
      setChecked(  true)
    }
    props.handleDatasetClick(props.dataset,!checked)
  }
  useEffect(() => {
    setChecked( props.checked)
    const timer = setTimeout(() => {
      setHelpTool(false);
    }, 5000);
    return () => clearTimeout(timer);
  });
  function changeFile(event) {
      props.changeFile( event.target.files[0]);
  }
  function clickHelpIcon() {
    setHelpTool(!helpTool)
  }
  const handleChange = (event) => {
    console.log(event.target.value)
    setName(event.target.value);
    props.handleDatasetNewName(event.target.value)
  };
  return (
    <Card className={classes.card}>
      <CardActionArea className={classes.actionArea} disabled>
        <CardMedia
            className={classes.media}
            image={WekaLogo}
            title={props.dataset.name}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {props.language.labels[props.language.id].newArrf}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions style={{marginTop:-27}}>

        <TextOnlyTooltip title={props.language.labels[props.language.id].help4} arrow={true} open={helpTool}>
        <FormControlLabel
            style={{width:"50%",color:"#4caf50",textAlign:"center"}}
            control={
              <Checkbox
                  checked={checked}
                  onChange={handleDatasetChange}
                  value="checked"
                  color="primary"
              />
            }
            label={props.language.labels[props.language.id].select.toUpperCase()}

        />
        </TextOnlyTooltip>
        <Tooltip title="Name to identify dataset" placement="top">
          <TextField
              id="standard-name"
              className={classes.textFieldName}
              value={name}
              onChange={handleChange}
              margin="normal"
          />
        </Tooltip>
        <Tooltip title="Dataset file in arff format" placement="top">
          <Button
              className={classes.file}
              component="label"
              color="primary"
          >
            {props.language.labels[props.language.id].file}
            <input
                onChange={changeFile}
                style={{display: "none"}}
                type="file"
            />
          </Button>
        </Tooltip>
        <Button size="small" className={classes.buttonInfo} onClick={clickHelpIcon}>
          {props.language.labels[props.language.id].info}
        </Button>
      </CardActions>
    </Card>
  );
}

DatasetCardBeginner.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DatasetCardBeginner);
